<span [class]="linkClass" (click)="onToggle()">
  <img
    [src]="isFavorite ? 'assets/icon-heart-red.svg' : 'assets/icon-heart.svg'"
    width="110"
    height="104"
    [alt]="isFavorite ? 'Your favorite' : 'Add to favorites'"
  />
</span>
